import Vue from "vue";
import Component from "vue-class-component";
import moment from "moment/moment";

@Component
export default class ChartsCommon extends Vue {
  public titre: string = "";
  public colors = [
    "#26A69A",
    "#1976D2",
    "#EF5350",
    "#FFD54F",
    "#7E57C2",
    "#03C9A9",
    "#C0392B",
    "#2574A9",
    "#6C7A89",
    "#1EBC61",
    "#BD02B0",
    "#0057A0",
    "#1EBC61",
    "#870000",
  ];

  public colorsComplex = [
    { borderColor: "#ffffff", backgroundColor: "rgba(255, 255, 255, 0.6)" },
    { borderColor: "#EF5350", backgroundColor: "rgba(239,83,80,0.4)" },
    { borderColor: "#311B92", backgroundColor: "rgba(49,27,146,0.7)" },
    { borderColor: "#ffd54f", backgroundColor: "rgba(255,213,79,0.5)" },
    { borderColor: "#BD02B0", backgroundColor: "rgba(189, 2, 176, 0.4)" },
    { borderColor: "#7E57C2", backgroundColor: "rgba(126, 87, 194, 0.4)" },
  ];

  public quartFilter(lignes: any) {
    const lignesDates: any = {};
    const endLignes: any = {};
    const labels = Object.keys(lignes);
    labels.forEach((index: any) => {
      let date = moment().hours(0).minutes(0).seconds(0);
      if (index < 24) {
        date = date.add(1, "day");
        const minutes = index * 15;
        const heure = date.add(minutes, "minutes");
        const myindex = heure.format("YYYY-MM-DDTHH:mm:ss");
        endLignes[myindex] = lignes[index];
      } else {
        const minutes = index * 15;
        const heure = date.add(minutes, "minutes");
        const myindex = heure.format("YYYY-MM-DDTHH:mm:ss");
        lignesDates[myindex] = lignes[index];
      }
    });
    return Object.assign(lignesDates, endLignes);
  }

  public dateOrdering(periode: string, date: Date): string {
    let dateFilter = "";
    moment.locale(this.$i18n.locale);
    switch (periode) {
      case "J":
        dateFilter += moment(date).format("DD MMMM yyyy");
        break;
      case "SEMAINE":
        dateFilter += moment(date).format("w yyyy");
        break;
      case "MOIS":
        dateFilter += moment(date).format("MMMM yyyy");
        break;
      case "ANNEE":
        dateFilter += moment(date).format("yyyy");
        break;
    }
    return dateFilter;
  }
  /**
   * mise a jour du titre avec la periode
   * @param myOptions options de configuration du graph
   * @param graphTitle le titre du graphique
   */
  public orderTitre(myOptions: any, graphTitle?: string): any {
    if (graphTitle) {
      graphTitle += " - ";
    } else {
      graphTitle = "";
    }
    switch (myOptions.periode) {
      case "J":
        graphTitle += moment(myOptions.date)
          .locale(this.$i18n.locale)
          .format("DD MMMM yyyy");
        break;
      case "SEMAINE":
        graphTitle +=
          this.$t("Semaine").toString() +
          " " +
          moment(myOptions.date).locale(this.$i18n.locale).format("w yyyy");
        break;
      case "MOIS":
        graphTitle += moment(myOptions.date)
          .locale(this.$i18n.locale)
          .format("MMMM yyyy");
        break;
      case "ANNEE":
        graphTitle += moment(myOptions.date)
          .locale(this.$i18n.locale)
          .format("yyyy");
        break;
    }
    this.titre = graphTitle;
  }
}
